var map = {
	"./EnConstruccion-transformed.jpeg": "6a51",
	"./EnConstruccion.jpeg": "2563",
	"./EnConstruccion.jpg": "2e63",
	"./articulos/noti4.jpeg": "3874",
	"./articulos/noti5.jpg": "3e51",
	"./articulos/noti6.jpg": "b4c6",
	"./comunidad.jpeg": "da92",
	"./emprendimiento-comunitario.jpeg": "a3bd",
	"./gobierno.jpeg": "1143",
	"./img-programando.png": "a0bb",
	"./img1.jpg": "5ea3",
	"./img2.jpg": "cdd8",
	"./logo.png": "cf05",
	"./noti4.jpeg": "6b3e",
	"./noti5.jpg": "0ce4",
	"./noti6.jpg": "7074"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";